import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, Phone, ChevronRight, MessageCircle } from "lucide-react";
import SEO from "../components/SEO";

const suggestions = [
  { name: "Aannemer", path: "/aannemer" },
  { name: "Badkamer Renovatie", path: "/badkamer-renovatie" },
  { name: "Stukadoor", path: "/stukadoor" },
  { name: "Schilderwerk", path: "/schilderwerk" },
  { name: "Timmerwerk", path: "/timmerwerk" },
  { name: "Werk op uurtarief", path: "/uurtarief" },
];

export default function NotFoundPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="not-found-page">
      <SEO
        title="Pagina niet gevonden - Cardoso Bouw en Onderhoud"
        description="Deze pagina bestaat niet (meer). Bekijk onze diensten of neem contact op met Cardoso Bouw en Onderhoud."
        noindex
      />
      <section className="relative min-h-[60vh] flex items-end bg-[#005F5F]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pb-16 pt-40 w-full">
          <p className="text-[#C5A059] font-bold uppercase tracking-[0.2em] text-sm mb-4">Foutmelding 404</p>
          <h1 className="font-['Barlow_Condensed'] text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white uppercase leading-tight">
            Deze pagina bestaat niet
          </h1>
          <p className="text-white/70 text-base mt-4 max-w-lg">
            De pagina die u zoekt is verplaatst of bestaat niet meer. Geen zorgen, via onderstaande links vindt u snel wat u zoekt.
          </p>
          <div className="flex flex-wrap gap-4 mt-10">
            <Link
              to="/"
              data-testid="not-found-home-btn"
              className="bg-[#C5A059] hover:bg-white hover:text-[#005F5F] text-white font-bold uppercase tracking-wider px-8 py-4 text-sm transition-all duration-300 flex items-center gap-2"
            >
              <Home className="w-4 h-4" />
              Naar de homepage
            </Link>
            <Link
              to="/contact"
              data-testid="not-found-contact-btn"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#005F5F] font-bold uppercase tracking-wider px-8 py-4 text-sm transition-all duration-300 flex items-center gap-2"
            >
              <MessageCircle className="w-4 h-4" />
              Contact
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <h2 className="font-['Barlow_Condensed'] text-2xl sm:text-3xl font-bold uppercase text-[#0F172A] mb-6">
              Misschien zocht u een van onze diensten
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {suggestions.map((s) => (
                <Link
                  key={s.path}
                  to={s.path}
                  data-testid={`not-found-link-${s.path.replace("/", "")}`}
                  className="group flex items-center justify-between p-4 bg-slate-50 border border-slate-200 hover:border-[#C5A059] transition-colors"
                >
                  <span className="font-medium text-slate-700 group-hover:text-[#005F5F]">{s.name}</span>
                  <ChevronRight className="w-4 h-4 text-[#C5A059] group-hover:translate-x-1 transition-transform" />
                </Link>
              ))}
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="bg-[#005F5F] p-8 text-white">
              <h3 className="font-['Barlow_Condensed'] text-xl font-bold uppercase mb-4">Liever direct contact?</h3>
              <p className="text-white/70 text-sm mb-6">Bel of WhatsApp ons. Wij helpen u graag verder.</p>
              <a
                href="tel:+31685071009"
                data-testid="not-found-phone"
                className="flex items-center justify-center gap-2 w-full py-3 bg-[#C5A059] hover:bg-white hover:text-[#005F5F] text-white font-bold uppercase tracking-wider text-sm transition-all duration-300"
              >
                <Phone className="w-4 h-4" />
                06 85 07 10 09
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
